import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';
import '../styles/Premium.css';

const PLANS = {
    godly_plus: {
        name: 'Godly+',
        tagline: 'For the intentional dater',
        color: '#E8C547',
        features: [
            '20 likes per day',
            '100 swipes per day',
            'See who liked you',
            '1 new chat per day',
        ],
        prices: {
            monthly:   { amount: '₦1,300',  label: '1 Month' },
            '3months': { amount: '₦3,000',  label: '3 Months', saving: 'Save 17%' },
            '6months': { amount: '₦6,000',  label: '6 Months', saving: 'Save 17%' },
            annual:    { amount: '₦10,000', label: '1 Year',   saving: 'Save 17%' },
        },
    },
    platinum: {
        name: 'Platinum',
        tagline: 'For the serious pursuer',
        color: '#B0C4DE',
        features: [
            'Rewind swipes',
            'Unlimited swipes',
            'Unlimited chats',
            'See who liked you',
            'Unlimited likes',
            'Priority in discovery',
            'Priority support',
        ],
        prices: {
            monthly:   { amount: '₦5,000',  label: '1 Month' },
            '3months': { amount: '₦13,000', label: '3 Months', saving: 'Save 13%' },
            '6months': { amount: '₦25,000', label: '6 Months', saving: 'Save 13%' },
            annual:    { amount: '₦50,000', label: '1 Year',   saving: 'Save 17%' },
        },
    },
};

const DURATIONS = ['monthly', '3months', '6months', 'annual'];
const DURATION_LABELS = {
    monthly:   '1 Month',
    '3months': '3 Months',
    '6months': '6 Months',
    annual:    '1 Year',
};

export default function PremiumPage() {
    const navigate = useNavigate();
    const [selectedDuration, setSelectedDuration] = useState('monthly');
    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        API.get('/api/billing/status')
            .then((res) => { if (!cancelled) setSubscription(res.data); })
            .catch(() => {})
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);
       const [setPaymentUrl] = useState(null);
    const handleSubscribe = async (tier, duration) => {
        setError(null);
        setPaymentUrl(null);
        try {
            setActionLoading(true);
            const response = await API.post('/api/billing/checkout', { tier, duration });
            if (!response.data.payment_url) {
                setError('No payment URL returned. Please try again.');
                return;
            }
            // Don't auto-redirect with JS here — installed home-screen apps on
            // Android (WebAPKs) can trap JS-driven navigation inside their own
            // restricted container, leaving the payment link unreachable and
            // the page blank. Showing a real tappable link instead is handled
            // natively by the OS and reliably opens the real browser. See the
            // donate flow (DonatePage.jsx) for the same fix.
            setPaymentUrl(response.data.payment_url);
        } catch (err) {
            setError(err.response?.data?.message || 'Could not start checkout. Please try again.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleCancel = async () => {
        if (!window.confirm('Cancel your Godly Match subscription?')) return;
        try {
            setActionLoading(true);
            await API.post('/api/billing/cancel');
            alert('Subscription cancelled.');
            window.location.reload();
        } catch (err) {
            setError('Could not cancel subscription. Please try again.');
        } finally {
            setActionLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="premium-page">
                <div className="premium-loading">Loading...</div>
            </div>
        );
    }

    return (
        <div className="premium-page">
            <header className="premium-header">
                <button className="premium-back" onClick={() => navigate(-1)} aria-label="Back">
                    ←
                </button>
                <h1>Upgrade Your Plan</h1>
                <div className="premium-spacer" />
            </header>

            {error && <div className="premium-error">{error}</div>}

            {subscription?.is_premium && (
                <div className="current-plan-banner">
                    <span>✓</span>
                    <div>
                        <strong>
                            You're on {subscription.tier === 'platinum' ? 'Platinum' : 'Godly+'}
                        </strong>
                        {subscription.current_period_end && (
                            <p>
                                Renews on{' '}
                                {new Date(subscription.current_period_end).toLocaleDateString()}
                            </p>
                        )}
                    </div>
                </div>
            )}

            <div className="duration-tabs">
                {DURATIONS.map((d) => (
                    <button
                        key={d}
                        className={`duration-tab ${selectedDuration === d ? 'active' : ''}`}
                        onClick={() => setSelectedDuration(d)}
                    >
                        {DURATION_LABELS[d]}
                    </button>
                ))}
            </div>

            <div className="plan-cards">
                {Object.entries(PLANS).map(([tierKey, planData]) => {
                    const price = planData.prices[selectedDuration];
                    const isCurrentPlan =
                        subscription?.tier === tierKey &&
                        subscription?.duration === selectedDuration &&
                        subscription?.is_premium;

                    return (
                        <div
                            key={tierKey}
                            className="plan-card"
                            style={{ borderColor: planData.color }}
                        >
                            <div
                                className="plan-card-header"
                                style={{ backgroundColor: planData.color }}
                            >
                                <h2>{planData.name}</h2>
                                <p>{planData.tagline}</p>
                            </div>

                            <div className="plan-price">
                                <span className="amount">{price.amount}</span>
                                <span className="period"> / {price.label}</span>
                                {price.saving && (
                                    <span className="saving">{price.saving}</span>
                                )}
                            </div>

                            <ul className="plan-features">
                                {planData.features.map((f, i) => (
                                    <li key={i}>✓ {f}</li>
                                ))}
                            </ul>

                                                                                   {isCurrentPlan ? (
                                <button className="plan-btn current" disabled>
                                    Current Plan
                                </button>
                            ) : (
                                <button
                                    className="plan-btn"
                                    style={{ backgroundColor: planData.color }}
                                    onClick={() => handleSubscribe(tierKey, selectedDuration)}
                                    disabled={actionLoading}
                                >
                                    {actionLoading ? 'Loading...' : `Get ${planData.name}`}
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>

            {subscription?.is_premium && (
                <button
                    className="cancel-btn"
                    onClick={handleCancel}
                    disabled={actionLoading}
                >
                    Cancel subscription
                </button>
            )}

            <p className="legal-text">
                Secure payment powered by Flutterwave. By subscribing you agree to our
                Terms and Privacy Policy. Subscriptions auto-renew until cancelled.
            </p>
        </div>
    );
}